document.addEventListener('DOMContentLoaded', () => {
	const footerYear = document.querySelector('.footer__bottom-text-year')
	const faqQuestions = document.querySelectorAll('.faq__questions-question')
	const faqQuestionsButtons = document.querySelectorAll('.faq__questions-question-button')

	faqQuestions.forEach(question => {
		const btn = question.querySelector('.faq__questions-question-button')
		btn.addEventListener('click', () => {
			const isAlreadyOpen = question.classList.contains('open')
			faqQuestions.forEach(q => q.classList.remove('open'))
			if (!isAlreadyOpen) {
				question.classList.add('open')
			}
		})
	})

	faqQuestionsButtons.forEach(function (button) {
		button.addEventListener('click', function () {
			const isExpanded = this.getAttribute('aria-expanded') === 'true'
			faqQuestionsButtons.forEach(function (btn) {
				btn.setAttribute('aria-expanded', 'false')
			})
			if (!isExpanded) {
				this.setAttribute('aria-expanded', 'true')
			}
		})
	})

	const handleCurrentYear = () => {
		const year = new Date().getFullYear()
		footerYear.innerText = year
	}

	handleCurrentYear()
})
